import anime from "animejs";

//////////////////GENERAL VARIABLES

let menuFullMode = true; //is menu big(full) or small(mini) mode?
let sidebarFullMode = true; //is menu big(full) or small(mini) mode?
let animationTrigger; // identifies witch module activate the animation (menu or sidebar)


//////////////////MENU TRANSITIONS SET
function animTopModuleSmall() {
    anime({
        targets: "#module-top",
        width: {
            value: '-=180'
        },
        translateX:{
            value:'+=180'
        },
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250
    });
}
function animLeftModuleSmall() {
    anime({
        targets: "#module-left",
        width: 70,
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        delay: 150,
        complete: function () {
            menuFullMode = false;
        }
    });
}
function animCenterModuleSmall() {
    if(animationTrigger == 'menu'){
        anime({
            targets: "#module-center",
            width: {
                value: '-=180'
            },
            translateX:{
                value:'+=180'
            },
            easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
            duration: 250
        });
    }
    if(animationTrigger == 'sidebar'){
        anime({
            targets: "#module-center",
            width: {
                value: '-=280'//variável com a largura da sidebar -20px
            },
            easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
            duration: 250
        });
    }
}
function animMenuItensSmall() {
    anime({
        targets: ".v-list-item__content",
        opacity: 0,
        delay: (elm, index, t) => index * 20,
        easing: 'linear',
        duration: 100,
        complete: function () {
            toggleDisplay('v-list-item__content', 'none')
        }
    });
}
function animTopModuleBig() {
    anime({
        targets: "#module-top",
        width: {
            value: '+=180'
        },
        translateX:{
            value:'-=180'
        },
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        delay: 150
    });
}
function animLeftModuleBig() {
    anime({
        targets: "#module-left",
        width: 300,
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        complete: function () {
            menuFullMode = true;
        }
    });
}
function animCenterModuleBig() {
    if(animationTrigger == 'menu'){
        anime({
            targets: "#module-center",
            width: {
                value: '+=180'//variável com a largura do menu
            },
            translateX:{
                value:'-=180'//variável com a largura do menu
            },
            easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
            duration: 250,
            delay: 150
        });
    }
    if(animationTrigger == 'sidebar'){
        anime({
            targets: "#module-center",
            width: {
                value: '+=280'//variável com a largura da sidebar - 20px
            },
            easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
            duration: 250
        });
    }
}
function animMenuItensBig() {
    anime({
        targets: ".v-list-item__content",
        opacity: 1,
        delay: (elm, index, t) => index * 30,
        easing: 'linear',
        duration: 100
    });
}
function animMoveLogoSmall() {
    anime({
        targets: ".logo",
        left: '-=80',
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        delay: 150
    });
}
function animMoveLogoBig() {
    anime({
        targets: ".logo",
        left: '+=80',
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250
    });
}
function animLogoSmall() {
    anime({
        targets: ".main-logo",
        width: '-=180',
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        delay: 150
    });
}
function animLogoBig() {
    anime({
        targets: ".main-logo",
        width: '+=180',
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250
    });
}
function animLogoLetterHide(){
    anime({
        targets: '#svglogo>path',
        opacity: 0,
        delay: (elm, index, t) => index * 15,
        duration: 150
    });
}
function animLogoLetterShow(){
    anime({
        targets: '#svglogo>path',
        opacity: 1,
        delay: (elm, index, t) => index * 25,
        easing: 'linear',
        duration: 500
    });
} 
function animSidebarBig(){
    anime({
        targets: "#module-right",
        width: {
            value: '300'//variável com a largura da sidebar
        },
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        complete: function () {
            sidebarFullMode = true;
        }
    });
}
function animSidebarSmall(){
    anime({
        targets: "#module-right",
        width: {
            value: '20'
        },
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: 250,
        delay: 150,
        complete: function () {
            sidebarFullMode = false;
        }
    });
}

export default {
    data() {
        return {}
    },
    methods: {

        //////MAIN MENU ANIMATION
        animMenu() {
            animationTrigger = 'menu';
            if (menuFullMode) {
                animMenuItensSmall();
                animLeftModuleSmall();
                animCenterModuleBig();
                animTopModuleBig();
                animLogoSmall();
                animMoveLogoSmall();
                animLogoLetterHide();
            } else {
                toggleDisplay('v-list-item__content', 'flex');
                animMenuItensBig();
                animLeftModuleBig();
                animCenterModuleSmall();
                animTopModuleSmall();
                animLogoBig();
                animMoveLogoBig();
                animLogoLetterShow();
            }
        },
        //////SIDEBAR MENU ANIMATION
        animSidebar() {
            animationTrigger = 'sidebar';
           if(sidebarFullMode){
                animCenterModuleBig();
                animSidebarSmall();
                fadeOut(['.sidebarTop','.sidebarCenter', '.sidebarBottom'], 150, 0);
           }else{
                animCenterModuleSmall();
                animSidebarBig();
                fadeIn(['.sidebarTop','.sidebarCenter', '.sidebarBottom'], 150, 250);
           }
        }
    },
    mounted() {
        animSidebarSmall();
    },
};

//////////////////GENERAL FUNCTIONS//////////////////

//HIDE or SHOW
function toggleDisplay(className, displayState) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = displayState;
    }
}
//OPACITY
function toggleOpacity(className, displayState) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
        elements[i].style.opacity = displayState;
    }
}
//FADEOUT
function fadeOut(className, duration, delay){
    anime({
        targets: className,
        opacity:0,
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: duration,
        delay: delay,
        complete: function () {
            toggleOpacity(className, 'none');
        }
    });
}
function fadeIn(className, duration, delay){
    anime({
        targets: className,
        opacity:1,
        easing: 'cubicBezier(0.060, 0.900, 0.530, 1.000)',
        duration: duration,
        delay: delay,
        begin: function () {
            toggleOpacity(className, 'flex');
        }
    });
}